import { render, staticRenderFns } from "./UserAccessTab.vue?vue&type=template&id=4c349d94&scoped=true"
import script from "./UserAccessTab.vue?vue&type=script&lang=js"
export * from "./UserAccessTab.vue?vue&type=script&lang=js"
import style0 from "./UserAccessTab.vue?vue&type=style&index=0&id=4c349d94&prod&lang=scss&scoped=true"
import style1 from "./UserAccessTab.vue?vue&type=style&index=1&id=4c349d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c349d94",
  null
  
)

export default component.exports